
import { ReactNode } from "react";
import { Navigate } from "react-router";
import { PreferenceType } from "components/preferences";
import { usePreference } from "hooks/preferences";

type NavigateDefaultTabProps = {
    type: PreferenceType,
    fallback: ReactNode
};

const NavigateDefaultTab = (props: NavigateDefaultTabProps) => {
    const { type, fallback } = props;
    const [ loaded, settings, setSettings ] = usePreference(type);

    if (loaded === false) return <></>;
    
    return settings
        ? <Navigate to={settings.defaultTab!} replace={true} />
        : <>{fallback}</>;
}

export default NavigateDefaultTab;